import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, UrlSerializer } from '@angular/router';
import { th } from 'date-fns/locale';
import { GridComponent, TableMode } from 'src/app/components/grid/grid.component';
import { TableParams } from 'src/app/components/grid/TableParams';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { QueryOperand } from 'src/app/components/grid/QueryOperand';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { ExamOperationService } from 'src/app/exam-layout/operations/exam-operation.service';
import { IFileDownload } from 'src/app/interface/dto';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { firstValueFrom } from 'rxjs';
import { IFilterParam } from 'src/app/components/grid/IFilterParam';
import { ITableParams } from 'src/app/components/grid/ITableParams';

@Component({
  selector: 'app-examinationschedule',
  templateUrl: './examinationschedule.component.html',
  styleUrls: ['./examinationschedule.component.scss']
})
export class ExaminationscheduleComponent implements OnInit {

  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [
        {
          fieldName: 'examinationID',
          fieldValue: `${this.examService.selectedExamIds?.[0] ?? 0}`,
          queryOperand: QueryOperand['=='],
          static: true
        }
      ],
      sortParam: {
        fieldName: "",
        orderDirection: 0,
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Candidate Number',
      fieldName: 'examNo',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Examination ID',
      fieldName: 'examinationID',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Start Date/Time',
      fieldName: 'startDateTime',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Actual Start Date/Time',
      fieldName: 'actualStartDateTime',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Exam Paused',
      fieldName: 'examPaused',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'End Date/Time',
      fieldName: 'endDateTime',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Actual End Date/Time',
      fieldName: 'actualEndDateTime',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Status',
      fieldName: 'status',
      fieldDataType: FieldDataType.enum,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Score',
      fieldName: 'score',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Attempt',
      fieldName: 'attempt',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Can Take Exam',
      fieldName: 'canTakeExam',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'Added Minutes',
      fieldName: 'addedMinutes',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'Percentage Score',
      fieldName: 'percentageScore',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'Focus Loss Count',
      fieldName: 'focusLossCount',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'Exam Start Count',
      fieldName: 'examStartCount',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'SEB Config Key',
      fieldName: 'sEBConfigKey',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'SEB Config Key Version',
      fieldName: 'sEBConfigKeyVersion',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'Interview Proctor RequestID',
      fieldName: 'interviewProctorRequestID',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    // {
    //   displayName: 'Viewed Questions',
    //   fieldName: 'viewedQuestions',
    //   fieldDataType: FieldDataType.boolean,
    //   searchable: true,
    //   orderable: true,

    // }, 
    {
      displayName: 'ExtraField 1',
      fieldName: 'extraField1',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'ExtraField 2',
      fieldName: 'extraField2',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'ExtraField 3',
      fieldName: 'extraField3',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'ExtraField 4',
      fieldName: 'extraField4',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'Time Taken',
      fieldName: 'timeTaken',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'Network Availability Score',
      fieldName: 'networkAvailabilityScore',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'Restart Reason',
      fieldName: 'restartReason',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'Retake Count',
      fieldName: 'retakeCount',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'Examiner',
      fieldName: 'examiner',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'Last Checked For Import',
      fieldName: 'lastCheckedForImport',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'Override AI Prevent Exam Start',
      fieldName: 'overrideAIPreventExamStart',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'Recording Process Status',
      fieldName: 'recordingProcessStatus',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Recording Deleted',
      fieldName: 'recordingDeleted',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    }, {
      displayName: 'Last Interaction',
      fieldName: 'lastInteraction',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Disable SEB',
      fieldName: 'disableSEB',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,
    },
    {
      displayName: 'Allow External Webcam',
      fieldName: 'allowExternalWebcam',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,
    },
  ];
  gridName: string = "examScheduleGrid";
  constructor(private examService: ExamService, private snackBar: SnackbarService,
    private examSchService: ExamScheduleService,  private serializer: UrlSerializer,  private router: Router, private eventService: EventService, private actRoute: ActivatedRoute,) {
  }

  async ngOnInit() {
    const queryParams = await firstValueFrom(this.actRoute.params);
    let examid = queryParams['examid'];
    if (!this.examService.selectedExamIds?.[0]) {
      this.data.tableParams.filterParams = [
        {
          fieldName: 'examinationID',
          fieldValue: examid,
          queryOperand: QueryOperand['=='],
          static: true
        }
      ]
    }
    let candidateExamNo = this.actRoute.snapshot.queryParamMap.get('examNo') ?? '';

    if (candidateExamNo) {
      this.data.tableParams.filterParams = [
        {
          fieldName: 'examNo',
          fieldValue: candidateExamNo,
          queryOperand: QueryOperand['=='],
          static: true
        }
      ]
    }

    this.examSchService.reloadGrid.subscribe((value) => {
      this.refreshData(this.data.tableParams);
    });
    this.refreshData(this.data.tableParams);
  }

  onRowClick(exSchIdx: any) {
    if (exSchIdx && this.data.tableRows && this.data.tableRows.length > 0) {
      const examSchs = exSchIdx.map(x => this.data.tableRows[x]).filter(e => e !== undefined && e !== null);
      this.examSchService.selectedIds = examSchs.map(e => e.id);
      this.examSchService.selectedSchedules = examSchs;
      let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
      let selectedDataRowsId = storedIds.length > 0 ? storedIds : examSchs.map(x => x.id);
      GridUtil.setRowCliclk(this.gridName, exSchIdx, selectedDataRowsId);
    }

  }

  async refreshData(tableParams: ITableParams) {
    if (this.examService.selectedExamIds?.[0] && !tableParams.filterParams.find(f => f.fieldName == 'examinationID')) {
      var filter: IFilterParam =
      {
        fieldName: 'examinationID',
        fieldValue: `${this.examService.selectedExamIds?.[0]}`,
        queryOperand: QueryOperand['=='],
        static: true
      }

      tableParams.filterParams.push(filter);
    }
    const res = await this.examSchService.getExaminationSchedules(tableParams) as [];
    this.updateGridParams(res);
  }

  async exportScheduleClicked() {
    const res = await this.examSchService.getExamScheduleExport(this.data.tableParams).then((res: IFileDownload) => {
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', '' + 'data:application/octet-stream;base64,' + res.file);
      link.setAttribute('download', res.fileName + '.' + res.extension);
      document.body.appendChild(link);
      link.click();
      this.snackBar.success("Exam Exported successfully");
      link.remove();
    });
  }
  selectAllSchClicked() {
    this.examSchService.selectAll = !this.examSchService.selectAll;
    this.examService.selectAll = false;
  }
  updateGridParams(res: any) {
    if (!res) {
      return;
    }
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo }
    this.data.tableParams = tableParams;
    this.data.tableRows = res.slice(1, res.length);
    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    });
  }
  veiwDetialsClicekd(mode: string) {
    let schId = this.examSchService.selectedIds[0];
    this.router.navigate([`exams/${this.examService.selectedExamIds[0]}/schedules/${schId}`], {
      queryParams: { mode: mode, examschid: schId }
    });
  }

  addScheduleClicked(origin: any) {
    let schId = this.examSchService.selectedIds[0];
    this.router.navigate([`exams/${this.examService.selectedExamIds[0]}/schedules/${schId}`], {
      queryParams: { mode: 'add' }
    });
  }
  deleteScheduleClicked() {
    if (this.examSchService.selectedIds.length === 0) {
      this.snackBar.error("Please select a schedule to delete");
      return;
    }
    let data = { selectedIds: this.examSchService.selectedIds };
    const reportTree = this.router.createUrlTree([], { queryParams: data });
    let params = this.serializer.serialize(reportTree).split('?', 2)[1];

    this.examSchService.deleteSchedule(params).then((res) => {
      if (res) {
        this.refreshData(this.data.tableParams);
        this.snackBar.success("Schedule deleted successfully");
      } else {
        this.snackBar.error("Failed to delete schedule");
      }
    });
  }
  copyScheduleClicked(event) {
    let schId = this.examSchService.selectedIds[0];
    if (!schId) {
      return;
    }
    this.router.navigate([`exams/${this.examService.selectedExamIds[0]}/schedules/${schId}`], {
      queryParams: { mode: 'copy' }
    });
  }
}
